module.exports = __webpack_public_path__ + "img/SS_V_Basic_Fighting.b9659ab9.png";